var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEye = function SvgEye(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 24,
    viewBox: "0 0 37 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.332031,
    width: 36,
    height: 24,
    rx: 12,
    fill: "url(#paint0_linear_484_838)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_484_838)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.332 8C13.9858 8 10.6416 11.6719 10.6416 11.6719L10.332 12L10.6416 12.3281C10.6416 12.3281 13.6905 15.6621 17.7455 15.9688C17.939 15.9922 18.1324 16 18.332 16C18.5316 16 18.7251 15.9922 18.9186 15.9688C22.9736 15.6621 26.0225 12.3281 26.0225 12.3281L26.332 12L26.0225 11.6719C26.0225 11.6719 22.6783 8 18.332 8ZM18.332 9C19.4807 9 20.5398 9.30078 21.4603 9.70312C21.7923 10.2305 21.9817 10.8379 21.9817 11.5C21.9817 13.3066 20.5683 14.791 18.7394 14.9844C18.7292 14.9863 18.717 14.9824 18.7068 14.9844C18.5825 14.9902 18.4583 15 18.332 15C18.1935 15 18.0591 14.9922 17.9247 14.9844C16.0958 14.791 14.6823 13.3066 14.6823 11.5C14.6823 10.8477 14.8656 10.2402 15.1874 9.71875H15.1711C16.0999 9.30859 17.1711 9 18.332 9ZM18.332 10C17.4685 10 16.7679 10.6719 16.7679 11.5C16.7679 12.3281 17.4685 13 18.332 13C19.1956 13 19.8962 12.3281 19.8962 11.5C19.8962 10.6719 19.1956 10 18.332 10ZM13.7699 10.4688C13.6884 10.8047 13.6396 11.1426 13.6396 11.5C13.6396 12.377 13.9003 13.1973 14.3565 13.8906C13.0428 13.1621 12.1304 12.293 11.831 12C12.0815 11.7539 12.7801 11.1016 13.7699 10.4688ZM22.8941 10.4688C23.884 11.1016 24.5825 11.7539 24.833 12C24.5337 12.293 23.6212 13.1621 22.3076 13.8906C22.7638 13.1973 23.0245 12.377 23.0245 11.5C23.0245 11.1426 22.9756 10.8008 22.8941 10.4688Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_484_838",
    x1: 20.832,
    y1: 18.3887,
    x2: 1.83203,
    y2: 6.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24C474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96FFB2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_484_838"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(10.332 4)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEye);
export default ForwardRef;